import { Link } from "react-router-dom";

interface SectionHeadingProps {
  kicker?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
}

export default function SectionHeading({
  kicker,
  title,
  description,
  actionLabel,
  actionTo,
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
      <div className="min-w-0">
        {kicker && (
          <p className="mb-2 flex items-center gap-2 text-[11px] tracking-[0.24em] text-accent-600 uppercase">
            <span className="h-1.5 w-1.5 rounded-full bg-accent-500"></span>
            {kicker}
          </p>
        )}
        <h2 className="font-heading text-xl text-foreground-950 md:text-2xl">{title}</h2>
        {description && (
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">{description}</p>
        )}
      </div>
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap text-sm text-foreground-700 transition-colors hover:text-accent-600"
        >
          {actionLabel}
          <i className="ri-arrow-right-line text-base"></i>
        </Link>
      )}
    </div>
  );
}